export const getActivePage = ({ app }) => app.activePage;

export const getLanguage = ({ app }) => app.language;
